import { render, staticRenderFns } from "./intelligentChannel.vue?vue&type=template&id=6e2584a5&scoped=true"
import script from "./intelligentChannel.vue?vue&type=script&lang=js"
export * from "./intelligentChannel.vue?vue&type=script&lang=js"
import style0 from "./intelligentChannel.vue?vue&type=style&index=0&id=6e2584a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2584a5",
  null
  
)

export default component.exports